import {AppConfig} from '../../lib/AppConfig';

export const isQuestionnairePage = (currentPath: string) => {
  return currentPath === AppConfig.QUESTIONNAIRE_WELCOME_PATH || currentPath === AppConfig.QUESTIONNAIRE_PATH;
};
